import { createRouter, createWebHistory } from 'vue-router'


//Import Company Routes 
import adminUserRoute from './adminUserRoute.js'
import companyUserRoute from './companyUsersRoute.js'
import i18n from '@/Lang/lang.js'
import { syncChecklistContextFromRoute } from '@/helpers/checklistCompletion'
//Merge all the route
const finalRoute = adminUserRoute.concat(companyUserRoute);

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes:finalRoute,
    linkActiveClass: 'active',
    linkExactActiveClass: "active"
})

router.beforeEach((to, from, next) => {
    syncChecklistContextFromRoute(to);
    var mainTitle = localStorage.getItem('companyName');
    if (mainTitle == null || mainTitle == '')
        mainTitle = 'Welcome';
    const titleName = (to.name == 'undefinded' || typeof to.name === 'undefined' || to.name == null)
        ? 'login'
        : to.name

    document.title = `${mainTitle} | ${titleName}`;
    window.scrollTo(0, 0);
    next();
})

export default router
